import { render, staticRenderFns } from "./LearningSuite.vue?vue&type=template&id=f9cc2a2e&scoped=true"
import script from "./LearningSuite.vue?vue&type=script&lang=js"
export * from "./LearningSuite.vue?vue&type=script&lang=js"
import style0 from "./LearningSuite.vue?vue&type=style&index=0&id=f9cc2a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cc2a2e",
  null
  
)

export default component.exports